import React, { useContext } from 'react';
import { Chip } from '@mui/material';
import { UserStateContext } from 'context/user-state-context';
import { DUE_TODAY_COLOR, OVERDUE_COLOR, formatDueDate, getDueState } from './task-manager.constants';
const NEUTRAL = {
  bg: '#EDF0F4',
  text: '#48566B'
};
const DONE = {
  bg: '#F3F3F4',
  text: '#848484'
};

/**
 * CIN-7073: a task's due date as a chip — one rendering for the list's Due column,
 * the board card, and (offered to the drawer session) the customer drawer.
 *
 *   no date  → "—" (or nothing when `compact`, so board cards stay quiet)
 *   overdue  → red "Overdue · Sep 22"
 *   today    → orange "Due today"
 *   upcoming → neutral "Due Sep 30"
 *   done     → grey "Due Sep 30" (kept as history; a completed task is never overdue)
 */
export const DueChip = ({
  task,
  compact = false
}) => {
  const {
    asCompany
  } = useContext(UserStateContext);
  const state = getDueState(task, asCompany?.timezone);
  if (state === 'none') {
    return compact ? null : <span>—</span>;
  }
  const date = formatDueDate(task.due_date);
  const {
    label,
    color
  } = {
    overdue: {
      label: `Overdue · ${date}`,
      color: OVERDUE_COLOR
    },
    today: {
      label: 'Due today',
      color: DUE_TODAY_COLOR
    },
    upcoming: {
      label: `Due ${date}`,
      color: NEUTRAL
    },
    done: {
      label: `Due ${date}`,
      color: DONE
    }
  }[state];
  return <Chip size="small" label={label} data-testid="task-due-chip" sx={{
    backgroundColor: color.bg,
    color: color.text,
    fontWeight: state === 'overdue' ? 600 : 500,
    ...(compact ? {
      height: '22px',
      fontSize: '12px'
    } : {})
  }} />;
};